import React from "react";
import Button, { ButtonProps } from "web/react/components/LEGACY_button/button";

type SecondaryButtonProps = Omit<ButtonProps, "styleType">;

export default function SecondaryButton(props: SecondaryButtonProps): JSX.Element {
    return <Button styleType="secondary" {...props} />;
}
